import React, { useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import { SalesLines } from "./inc/Components";
import moment from 'moment';
import { currencyFormat, displayPan } from "../../../../../helpers/utilities";


export const BTST1 = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, copy } = props;
    const classes = customStyles();
    const topSec = useRef('');

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const discountAmount = (items) => {
        const safeItems = items ?? [];
        if (!safeItems.length) return 0;
        let totalDiscount = Number(details?.cashDiscountAmount || 0);
        for (const v of items) {
            const qty = Number(v.quantity || 0);
            const price = Number(v.pricePerUnit || 0);
            const discountAmt = Number(v.discountAmount || 0);
            const discountPercent = Number(v.discountPercent || 0);

            // Line-level fixed discount
            totalDiscount += discountAmt;

            // Percentage discount
            const percentDiscount = ((qty * price) * discountPercent) / 100;

            if (v.amount < 0) {
                totalDiscount -= percentDiscount;
            } else {
                totalDiscount += percentDiscount;
            }
        }

        return Number(totalDiscount.toFixed(2));
    }

    return (
        <>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                {
                    proformaPreview ? <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>Proforma</div> :
                        <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>
                            {
                                preview || details?.invoiceAmount >= 0 ? `${details?.includeGst ? 'Tax Invoice' : 'Invoice'}` : 'Debit Note'
                            }
                            <span>{`${copy ? 'Duplicate Copy' : 'Original'}`}</span></div>
                }
            </div>
            <div className={classes.downloaddetails}>
                <div ref={topSec}>
                    <Row>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.billtoppadding, classes.billCustom)}>
                            <Row type="flex" gutter={15}>
                                {/* {
                                businessDetails?.logoUri &&
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={classes.dispalyIF}>
                                    <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                        <FileUpload
                                            filePath={businessDetails?.logoUri || ''}
                                            view={true}
                                        />
                                    </div>
                                </Col>
                            } */}
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <h1>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.supplier?.name || '---'}</h1>
                                    <div className={classes.bill}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                                    </div>
                                    <Row className={clsx(classes.bill, classes.margin15t)}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row>
                                                <Col span={24}>
                                                    <Row>
                                                        <Col span={3}>
                                                            <h6>Email</h6>
                                                        </Col>
                                                        <Col span={21}>
                                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || '---'}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={12}>
                                                    <Row>
                                                        <Col span={6}>
                                                            <h6>Ph No.</h6>
                                                        </Col>
                                                        <Col span={18}>
                                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || '---'}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {
                                                    (details.includeGst || preview) && <Col span={12}>
                                                        <Row className={classes.overlFlowResponsiveDesign}>
                                                            <Col span={6}>
                                                                <h6>GSTIN</h6>
                                                            </Col>
                                                            <Col span={18}>
                                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplier?.gstin || details?.supplier?.gstin || '---'}</p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                                {
                                                    details?.supplier?.pan && <Col span={24}>
                                                        <Row>
                                                            <Col span={3}>
                                                                <h6>{displayPan(details?.supplier?.pan)[0]}</h6>
                                                            </Col>
                                                            <Col span={21}>
                                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.supplier?.pan)[1]}</p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.yellowBorderTop)}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.borderRight, classes.bill, classes.billtoppadding)}>
                            <h6>Bill To</h6>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : businessDetails?.businessName || details?.business?.name || '---'}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.bill, classes.billtoppadding)}>
                            <h6>Shipped To</h6>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : businessDetails?.businessName || details?.business?.name || '---'}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billbottompadding)}>
                            <Row>
                                <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>Email</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    (details.includeGst || preview) &&
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>GSTIN</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                {
                                    (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                            </Row>
                        </Col>
                        <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                            <Row>
                                <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>Email</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    (details.includeGst || preview) &&
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>GSTIN</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                {
                                    (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill)}>
                            <Row>
                                <Col span={13} style={{ padding: "0" }}>
                                    <h6>{preview || proformaPreview || details?.invoiceAmount >= 0 ? 'Invoice Number' : 'Debit Note'}</h6>
                                    <h1 style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplierRefNum || details?.reference || '---'}</h1>
                                </Col>
                                <Col span={6} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Invoice Date</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : '---'}</p>
                                    </div>
                                </Col>
                                <Col span={5} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Due Date</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.dueDate ? moment(details.dueDate).format('DD MMM YYYY') : '---'}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.paddingTop15)}>
                                <Col span={12} style={{ padding: "0" }}>
                                </Col>
                                <Col span={6} style={{ padding: "0" }}>

                                </Col>
                                <Col span={6} style={{ padding: "0" }}>

                                </Col>
                            </Row>
                        </Col>
                        <Col span={12} className={clsx(classes.bill)}>
                            <Row>
                                <Col span={7}>
                                    <div>
                                        <h6>Inv. Amnt</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}</p>
                                    </div>
                                </Col>
                                <Col style={{ padding: 0 }} span={6} >
                                    <div>
                                        <h6>Net Amnt</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.assessableValue || (details?.selfBillItems ? details?.invoiceAmount - (details?.roundOffAmount || 0) - details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0))}`}</p>
                                    </div>
                                </Col>

                                {
                                    details?.roundOffAmount !== 0 && <Col span={5}>
                                        <div>
                                            <h6>Round Off</h6>
                                            <p>{currencyFormat(details?.roundOffAmount)}</p>
                                        </div>
                                    </Col>
                                }
                                {
                                    (details?.includeGst || preview) &&
                                    <Col span={6}>
                                        <div>
                                            <h6>GST Amnt</h6>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}</p>
                                        </div>
                                    </Col>
                                }
                            </Row>
                            <Row className={clsx(classes.paddingTop15)}>
                                <Col span={7} className={clsx(classes.bill)}>
                                    <div>
                                        <h6>Place of Supply</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.state?.name || details?.business?.state?.name || '---'}</p>
                                    </div>
                                </Col>
                                <Col span={6} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Pmt. Method</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.mop?.method || '---'}</p>
                                    </div>
                                </Col>
                                <Col span={5} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Currency</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.currency?.name || '---'}</p>
                                    </div>
                                </Col>
                                {
                                    (discountAmount(details?.selfBillItems) > 0 || preview) && <Col span={6}>
                                        <div>
                                            <h6>Discount</h6>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(discountAmount(details?.selfBillItems))}`}</p>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row >
                    {
                        (details?.dispatchDetails || details?.comments) && <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                            {
                                details?.dispatchDetails && <Col span={5} className={clsx(classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                                    <div>
                                        <h6>Dispatch Details</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.dispatchDetails || '---'}</p>
                                    </div>
                                </Col>
                            }
                            {
                                details?.comments &&
                                <Col span={details?.dispatchDetails ? 19 : 24} className={clsx(classes.borderLeft, classes.bill)} style={{ padding: "10px 15px 3px 40px" }}>
                                    <div>
                                        <h6>Comments</h6>
                                        <p style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.comments || '---'}</p>
                                    </div>
                                </Col>
                            }
                        </Row>
                    }
                </div >
                <div className={clsx(classes.yellowBorderTop)}>
                    <div className={clsx(classes.thirdSection,)}><SalesLines topSec={topSec} ref={ref} {...props} terms={true} /></div>
                </div>
            </div >
        </>
    )
})